<template>
  <div>
    <dashboard-page-title
      :showFilter="false"
      :showSearch="false"
      :showExportation="false"
      :showAddBtn="false"
    >
      {{ $t('auth.termsCondition') }}
    </dashboard-page-title>

    <b-container fluid>
      <b-row>
        <b-col>
          <b-card class="shadow-sm">
            <h3 class="mb-3 text-right">الشروط والأحكام العامة لاستخدام منصة إبل</h3>
            <p class="text-muted text-right">
              هذه الصفحة تحتوي على نص تجريبي (Dummy Data) يوضح شكل الشروط والأحكام، ويمكن لاحقًا استبداله بالمحتوى
              القانوني المعتمد من جهة الاختصاص.
            </p>

            <hr>

            <h5 class="mt-3 mb-2 text-right">أولًا: التعريفات</h5>
            <ul class="text-right">
              <li>المنصة: يقصد بها منصة إبل الإلكترونية.</li>
              <li>المستخدم: كل شخص يقوم بإنشاء حساب أو يستخدم خدمات المنصة.</li>
              <li>الخدمات: جميع الخدمات الإلكترونية التي توفرها المنصة المتعلقة بالإبل.</li>
            </ul>

            <h5 class="mt-4 mb-2 text-right">ثانيًا: قبول الشروط</h5>
            <p class="text-right">
              باستخدامك للمنصة فأنت تقر بأنك قرأت هذه الشروط وفهمتها ووافقت على الالتزام بها، كما تقر بأن إدارة المنصة
              تحتفظ بالحق في تعديل هذه الشروط في أي وقت، ويتم الإعلان عن التعديلات داخل المنصة.
            </p>

            <h5 class="mt-4 mb-2 text-right">ثالثًا: حساب المستخدم</h5>
            <ul class="text-right">
              <li>يتحمل المستخدم مسؤولية سرية بيانات الدخول إلى حسابه.</li>
              <li>تحتفظ المنصة بالحق في إيقاف أو إلغاء أي حساب يخالف السياسات أو يستخدم بشكل غير قانوني.</li>
            </ul>

            <h5 class="mt-4 mb-2 text-right">رابعًا: استخدام الخدمات</h5>
            <p class="text-right">
              يلتزم المستخدم باستخدام الخدمات المتاحة عبر المنصة للأغراض المشروعة فقط، ووفق الأنظمة واللوائح المعمول بها
              في المملكة العربية السعودية، وعدم استغلال المنصة في أي نشاط مخالف أو ضار.
            </p>

            <h5 class="mt-4 mb-2 text-right">خامسًا: الملكية الفكرية</h5>
            <p class="text-right">
              كافة الحقوق المتعلقة بالتصاميم، والشعارات، والمحتوى، والبرمجيات، محفوظة لمنصة إبل، ولا يجوز نسخها أو إعادة
              استخدامها إلا بعد الحصول على موافقة خطية مسبقة.
            </p>

            <h5 class="mt-4 mb-2 text-right">سادسًا: إخلاء المسؤولية</h5>
            <p class="text-right">
              تُقدّم خدمات المنصة كما هي دون أي ضمانات مباشرة أو غير مباشرة، ولا تتحمل المنصة أي مسؤولية عن أي أضرار
              مباشرة أو غير مباشرة ناتجة عن استخدام الخدمات، ويقع على المستخدم وحده مسؤولية قراراته ومعاملاته.
            </p>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { core } from '@/config/pluginInit'

export default {
  name: 'TermsConditionPage',
  mounted () {
    core.index()
  }
}
</script>
